import React from 'react';
import PropTypes from 'prop-types';

import BoxTimeline from '../Timeline/BoxTimeline';
import AddressDetails from './AddressDetails';
import QuickLinks from './QuickLinks';
import CollapsiblePanel from '../CollapsiblePanel';
import BoxTextBodyLinks from './BoxTextBodyLinks';
import BoxImage from './BoxImage';
import Status from './Status';
import ReviewButton from './ReviewButton';
import { NOT_SUBSCRIBED } from './boxStatusId';

const ChallengeStatus = ({
  imageURL,
  name,
  id,
  title,
  body,
  trackingUrl,
  order: {
    currentOrderStep,
    orderSteps,
  },
  shippingAddress,
  isChallenge,
  isMobile,
  isTablet,
  screenMode,
  hasFailed,
  showReviewButton,
}) => (isMobile ? (
  <CollapsiblePanel title={screenMode !== 'desktop' && `${name ? name.toUpperCase() : 'BOX '} STATUS`}>
    <div className="mybox-container">
      <Status
        imageURL={imageURL}
        name={name}
        id={id}
        title={title}
        body={body}
        trackingUrl={trackingUrl}
        showReviewButton={showReviewButton}
        hasFailed={hasFailed}
        isMobile={isMobile}
      />
      <BoxTimeline nodes={orderSteps} currentStep={currentOrderStep} isMobile />
      <div className="challenge-divider" />
      <AddressDetails
        isChallenge={isChallenge}
        shippingAddress={shippingAddress}
        hasFailed={hasFailed}
        boxStatusId={id}
      />
      <QuickLinks statusId={id} isChallenge={isChallenge} />
      <div className="challenge-last-divider" />
    </div>
  </CollapsiblePanel>
) : (
  <section className="challenge-container">
    <div className="challenge-status-container-desktop">
      <div className="challenge-status-desktop">
        <BoxImage imageURL={imageURL} isChallenge={isChallenge} isMobile={isMobile} />
        <BoxTimeline nodes={orderSteps} currentStep={currentOrderStep} isMobile={false} />
        {!isTablet && (
        <QuickLinks statusId={id} isChallenge={isChallenge} />
        )}
      </div>
      <div className={`status-details-desktop${id === NOT_SUBSCRIBED ? '-not-sub' : ''}`}>
        <div className="challenge-status__details-desktop">
          <span>{`${hasFailed || !name ? 'BOX ' : name} STATUS`}</span>
          {!!title && <h3>{title}</h3>}
          <p className="challenge-status__body-desktop">
            {body}
          </p>
          <BoxTextBodyLinks boxStatusId={id} trackingUrl={trackingUrl} title={title} body={body} />
          {showReviewButton ? <ReviewButton desktop /> : null}
        </div>
        <div className="address-details-desktop">
          <AddressDetails
            isChallenge={isChallenge}
            shippingAddress={shippingAddress}
            hasFailed={hasFailed}
            boxStatusId={id}
          />
        </div>
      </div>
      {isTablet && (
      <div className="tablet-links">
        <QuickLinks statusId={id} isChallenge={isChallenge} />
      </div>
      )}
    </div>
    <div className="challenge-last-divider" />
  </section>
));

ChallengeStatus.defaultProps = {
  imageURL: '',
  name: '',
  title: '',
  body: '',
  trackingUrl: '',
  order: {
    currentOrderStep: '',
    orderSteps: [],
  },
  shippingAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    userName: '',
  },
  isChallenge: false,
  isMobile: true,
  isTablet: false,
  screenMode: 'mobile',
  hasFailed: false,
  showReviewButton: false,
};

ChallengeStatus.propTypes = {
  imageURL: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  trackingUrl: PropTypes.string,
  order: PropTypes.shape({
    currentOrderStep: PropTypes.string,
    orderSteps: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      message: PropTypes.string,
      order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })),
  }),
  shippingAddress: PropTypes.shape({
    shippingAddress: PropTypes.shape({
      address1: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postalCode: PropTypes.string,
      country: PropTypes.string,
      userName: PropTypes.string,
    }),
  }),
  isChallenge: PropTypes.bool,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  screenMode: PropTypes.string,
  hasFailed: PropTypes.bool,
  showReviewButton: PropTypes.bool,
};

export default ChallengeStatus;
